"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

// import useRedirect from '@sprinx/react-routes/useRedirect';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: '100%',
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      '&:not(:last-child)': {
        borderRight: '1px solid rgba(0,0,0,.2)'
      }
    }, theme.breakpoints.down('sm'), {
      width: '50%',
      marginBottom: theme.spacing(3),
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      marginTop: theme.spacing(3),
      '&:not(:last-child)': {
        borderRight: 'unset'
      },
      '&:nth-of-type(2n)': {
        borderLeft: '1px solid rgba(0,0,0,.2)'
      }
    }),
    avatar: {
      marginBottom: theme.spacing(2),
      '& > svg': (0, _defineProperty2.default)({
        width: 90,
        height: 90
      }, theme.breakpoints.down('xs'), {
        width: 50,
        height: 50
      })
    },
    title: (0, _defineProperty2.default)({
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      textAlign: 'center',
      textTransform: 'none',
      fontWeight: 400,
      color: theme.palette.text.primary
    }, theme.breakpoints.down('xs'), {
      fontSize: 16
    }),
    description: (0, _defineProperty2.default)({
      textAlign: 'center'
    }, theme.breakpoints.down('xs'), {
      fontSize: 14
    })
  };
}, {
  name: 'SxComHomePageWhyItem'
});

function HomePageWhyItem(_ref) {
  var category = _ref.category,
      pClasses = _ref.classes,
      className = _ref.className,
      translateKey = _ref.translateKey,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["category", "classes", "className", "translateKey"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)(); // const setRedirect = useRedirect();

  return (
    /*#__PURE__*/
    // eslint-disable-next-line
    _react.default.createElement("div", (0, _extends2.default)({}, rest, {
      className: (0, _clsx.default)(classes.root, className)
      /*onClick={() => setRedirect(category.href)}*/

    }), /*#__PURE__*/_react.default.createElement("span", {
      className: classes.avatar
    }, category.avatar), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "h3",
      color: "primary",
      className: classes.title
    }, t("homePageWhy/".concat(translateKey, "/title"))), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: classes.description
    }, t("homePageWhy/".concat(translateKey, "/content"))))
  );
}

process.env.NODE_ENV !== "production" ? HomePageWhyItem.propTypes = {
  category: _propTypes.default.shape({
    avatar: _propTypes.default.shape({}),
    description: _propTypes.default.arrayOf(_propTypes.default.shape({})),
    href: _propTypes.default.string,
    title: _propTypes.default.arrayOf(_propTypes.default.shape({}))
  }).isRequired,
  classes: _propTypes.default.shape({
    avatar: _propTypes.default.string,
    description: _propTypes.default.string,
    root: _propTypes.default.string,
    title: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  translateKey: _propTypes.default.number.isRequired
} : void 0;
HomePageWhyItem.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = HomePageWhyItem;
exports.default = _default;